module.exports = __webpack_public_path__ + "img/belt.64aa73fb.svg";